import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { SyncOutlined } from '@ant-design/icons';
import { useSyncInvoicesToInfakt } from 'api/invoices/use-sync-invoices-to-infakt';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard.tsx';
import type { IInfaktSyncButtonProps } from 'components/invoices/infakt-sync-button/types';

const InfaktSyncButtonComponent: React.FC<IInfaktSyncButtonProps> = (props) => {
  const { invoiceId } = props;
  const { t } = useTranslation('invoice');
  const { mutate: syncToInfakt, isLoading } = useSyncInvoicesToInfakt();

  const handleSync = () => syncToInfakt({ invoiceIds: [invoiceId] });

  return (
    <Button icon={<SyncOutlined spin={isLoading} />} loading={isLoading} onClick={handleSync}>
      {t('send_to_infakt')}
    </Button>
  );
};

export const InfaktSyncButton = withRoleGuard<IInfaktSyncButtonProps>(InfaktSyncButtonComponent, [
  UserRole.admin,
  UserRole.accountant,
  UserRole.assistant,
]);
